import * as React from "react";
import {imageBaseUrl} from "config";

interface IProps {
    heading: string;
    description: string;
    handleClick: () => void;
    completed?: boolean;
}

const Options = (props: IProps) => {
    return(
        <div className="option-container" onClick={() => props.handleClick()}>
            <div className="option-heading">
                <h1>{props.heading}</h1>
                <div className="icon">
                    <img
                        src={`${imageBaseUrl}/img/icons/${props.completed ? "round-checked.png" : "round-arrow.png"}`}
                        alt="click here"/>
                </div>
            </div>
            <div className="description">{props.description}</div>
        </div>
    );
};

export default Options;